import React from "react";
import {
  LightButton,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeaderWithTitleAndClose,
  PrimaryButton
} from "best-common-react";
import styled from "styled-components";
import { inject, observer } from "mobx-react";

const ConfirmMessage = styled.div.attrs({ className: "mb-3" })`
  font-size: 1.125rem;
  font-weight: 300;
`;

const Deleted = styled.span`
  font-size: 1.125rem;
  font-weight: bold;
`;

class DeleteTicketAccessOverrideModal extends React.Component {
  render() {
    const { eventDetailsStore } = this.props.rootStore;
    return (
      <Modal show={this.props.show} size="lg" onClose={() => {}}>
        <ModalHeaderWithTitleAndClose
          title="Delete Override(s)"
          onClose={() => {}}
          close={() => eventDetailsStore.setShowEventAccessDeleteModal(false)}
        />
        <ModalBody>
          <ConfirmMessage>
            Are you sure you want to delete the override(s) for
            {eventDetailsStore.selectedDepartment && eventDetailsStore.selectedDepartment.departmentType ? (
              <Deleted> {eventDetailsStore.selectedDepartment.departmentType.departmentName}</Deleted>
            ) : null}
            ?
          </ConfirmMessage>
        </ModalBody>
        <ModalFooter>
          <div>
            <PrimaryButton className="mr-2" onClick={eventDetailsStore.deleteEventAccessOverride} disabled={false}>
              Delete
            </PrimaryButton>
            <LightButton onClick={() => eventDetailsStore.setShowEventAccessDeleteModal(false)}>Cancel</LightButton>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default inject("rootStore")(observer(DeleteTicketAccessOverrideModal));
